export class NameValueOfString {
  public name: string;
  public value: string;

  constructor(n: any) 
  {
    this.name = n.name;
    this.value = n.value;
  }
}